<template>
  <b-modal
    centered
    id="add-claim-modal"
    title="Reklamationen erstellen"
    no-close-on-backdrop
    v-model="showModal"
    @ok="createClaim"
  >
    <div ref="modalbody">
      <h3 class="mb-3">
        Reklamationen - {{ vendor.name }} {{ moment().format("DD.MM.YYYY") }}
      </h3>
      <b-table
        id="tableToShow"
        striped
        hover
        :items="unprocessedPositions"
        :fields="fields"
				primary-key="id"
        class="mikasmallz"
      >
        <template #cell(Referenz)="row">
          <p class="position-relative">
            {{ row.item.delivery_note_position.reference }}
          </p>
        </template>
        <template #cell(quantity)="row">
          <b-form-input
            v-show="!printable"
            v-model="row.item.quantity"
            class="pl-2"
            style="width: 70px; height: 25px"
          ></b-form-input>
          <span v-show="printable"> {{ row.item.quantity }} </span>
        </template>
        <template #cell(claimCase)="row">
          <b-form-select
            v-show="!printable"
            v-model="row.item.itemSelected"
            :options="claimCaseOptions"
            class="mb-2 p-0 pl-2 mt-1"
            style="width: 150px; height: 25px; font-size: 15px"
          ></b-form-select>
          <div v-show="printable" class="mb-2 p-0 pl-2 mt-1">
            {{
              claimCaseOptions.find((opt) => opt.value == row.item.itemSelected)
                .text
            }}
          </div>
        </template>
        <template #cell(details)="row">
          <div v-show="!printable">
            <b-form-input
              :placeholder="row.item.detailsPlaceholder"
              no-resize
              v-model="row.item.details"
              :state="row.item.validationState"
              class="mt-1 pl-2"
              style="width: 150px; height: 25px"
              v-if="row.item.itemSelected != 2"
            ></b-form-input>
            <small class="">{{ row.item.errorMessage }}</small>
          </div>
          <div v-show="printable" class="mt-1 pl-2">
            {{ row.item.details }}
          </div>
        </template>
      </b-table>
      <!--b-btn variant="primary" @click="createClaim(unprocessedPositions)">Absenden</b-btn-->
    </div>
  </b-modal>
</template>
<script>
import html2pdf from "html2pdf.js";
/*
To-Do:
- validation für barcode korrigieren und gänzlich mal überpfüft werden
- function: daten werden validiert und per axios abgeschickt
- automatisches füllen der füllmenge?

*/
export default {
  props: {
    passedUnprocessedPositions: {
      type: Array,
      required: false,
    },
    vendor: {
      type: Object,
      required: false,
    },
    value: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
			unprocessedPositions: [],
      fields: [
        {
          key: "barcode",
          label: "EAN",
          sortable: false,
          tdClass: "py-1",
        },
        {
          key: "deliverynote.number",
          label: "LS-Nummer",
          sortable: false,
          tdClass: "py-1",
        },
        {
          key: "unprocessedQuantity",
          label: "Menge",
          sortable: false,
          tdClass: "py-1",
        },
        {
          key: "quantity",
          label: "Rek. Menge",
          sortable: false,
          tdClass: "py-1",
        },
        {
          key: "reference",
          label: "Referenz",
          sortable: false,
          tdClass: "py-1",
        },
        { key: "claimCase", label: "Reklamationsfall", sortable: false },
        { key: "details", label: "Details", sortable: false },
      ],
      claimCaseOptions: [
        { value: null, text: "Fall auswählen" },
        { value: 1, text: "Beschädigt" },
        { value: 2, text: "Fehlmenge" },
        { value: 3, text: "Falschlieferung" },
      ],
      validationMessage: null,
      printable: false,
    };
  },
  methods: {
    // über items loopen, valid state hinzufügen in unprossedPositions
    //need userId, Type, Details, deliveryNotePosition sendBackon?
    createClaim(event) {
      event.preventDefault();
      console.log(
        this.checkValidation(this.unprocessedPositions) + " validierungscheck",
      );
      if (this.checkValidation(this.unprocessedPositions)) {
        // daten zusammenführen
        console.log("validierung correct");

				const requests = [];
				this.unprocessedPositions.forEach(dnp => {
					requests.push(axios.post('/deliverynotepositionclaims', {
						type: dnp.itemSelected,
						details: dnp.details,
						quantity: dnp.quantity,
						deliveryNotePositionId: dnp.id,
					}));
				});

				this.exportToPDF().then(() => {
					this.showModal = false;
					this.$emit('claimsCreated');
				});

				Promise.all(requests)
						.then(responses => {
							responses.forEach(r => this.$emit('dnpProcessingAdded', r.data));
						})
						.catch(err => {
							console.log(err);
								this.$bvModal.msgBoxOk('Ein Fehler is aufgetreten. Bitte Überprüfen sie, ob die der/die Artikel richtig verarbeitet wurden.', {
									title: 'Fehler',
									okVariant: 'danger',
									centered: true,
								});
						})
      } else {
        console.log("validierung fehlgeshlagen");
      }
    },
    checkValidation(items) {
      let errorCount = 0;
      //Regex for up to 255 letters und punctuation
      const damagedArticleRegex = /^[a-zA-Z0-9\s.,?:-]{3,255}$/;

      //Regex for positve numbers from 1-100
      const incorrectDeliveryQuantityRegex = /^([1-9]|[1-9][0-9]|100)$/;

      //Regex for exact 13 numbers, it will not be checked for real EAN
      const incorrectArticleRegex = /^\d{9,13}$/;
      items.forEach((item) => {
        item.errorMessage = "";
        item.validationState = null;
        // console.log("initialised error count: "+ errorCount);
        switch (item.itemSelected) {
          case 1: //Damaged
            if (
              damagedArticleRegex.test(item.details) &&
              !(item.details == null)
            ) {
              item.validationState = true;
            } else {
              item.validationState = false;
              item.errorMessage = "mid. 3 Zeichen und keine Sonderzeichen";
              errorCount++;
            }
            console.log(
              "beschädigung " + damagedArticleRegex.test(item.details),
            );
            break;
          case 2: //Fehlmenge
            item.validationState = true;
            /*
                        if(incorrectDeliveryQuantityRegex.test(item.details)&&
                          item.details == (item.delivery_note_position.quantity-item.quantityProcessed)){
                            item.validationState = true;
                            item.errorMessage = "";
                        } else {
                            item.validationState = false;
                                                        
                            item.errorMessage = "positive Zahl, die nicht größer als die Menge ist";
                            errorCount++;                            
                        }
                        console.log(incorrectDeliveryQuantityRegex.test(item.details)+" liefermenge");*/
            break;
          case 3: //Falschlieferung
            console.log(item.details);

            if (incorrectArticleRegex.test(item.details)) {
              item.validationState = true;
              item.errorMessage = "";
            } else {
              item.validationState = false;
              item.errorMessage = "9-13 Ziffern werden benötigt";
              errorCount++;
            }
            console.log(
              incorrectArticleRegex.test(item.details) + " falscher artikel",
            );
            console.log(incorrectArticleRegex.toString());
            break;

          default:
            return errorCount++;
        }
      });
      console.log(errorCount);
      if (errorCount == 0) {
        items.forEach((item) => {
          item.errorMessage = "";
        });
      }

      if (errorCount == 0) {
        return true;
      } else {
        return false;
      }
    },
    exportToPDF() {
      return new Promise((resolve, reject) => {
        // documentation for html2pdf:
        // https://ekoopmans.github.io/html2pdf.js/
        let options = {
          margin: 10,
          pagebreak: { mode: "avoid-all", before: ".tr" },
          //landscape - horizontal //portrait - vertical - default
          jsPDF: { orientation: "landscape" },
        };

				this.togglePrintable();

				this.$nextTick(() => {
					requestAnimationFrame(() => {
						const element = this.$refs.modalbody;
						html2pdf()
								.set(options)
								.from(element)
								.outputPdf('arraybuffer')
								.then((data) => {
									const file = new Blob([data], { type: 'application/pdf' });
									const a = document.createElement('a');
									const url = URL.createObjectURL(file);
									a.href = url;
									a.download = 'Reklamationen-'+ this.vendor.name + '-' + moment().format("DD.MM.YYYY") + '.pdp';
									document.body.appendChild(a);
									a.click();
									setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 0);
									resolve();
								})
								.catch(reject)
								.finally(() => { this.togglePrintable(); });
					});
				});
      });
    },
    togglePrintable() {
      this.printable = !this.printable;
    },
		formatUnprocessedPositions() {
			this.unprocessedPositions = (this.passedUnprocessedPositions || []).map(dnp => {
				const processed = (dnp.deliverynotepositionprocesss || []).reduce(
						(sum, p) => sum + (Number(p.quantityProcessed) || 0),
						0
				);
				const qty = Math.max(0, (Number(dnp.quantity) || 0) - processed);

				return {
					...dnp,
					quantity: dnp.unprocessedQuantity || 1,
					itemSelected: null,
					unprocessedQuantity: qty,
					processedQuantity: processed,
					details: null,
					detailsPlaceholder: 'Details eingeben',
					validationState: null,
					errorMessage: ''
				};
			});
		}
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
		passedUnprocessedPositions() {
			this.formatUnprocessedPositions();
		}
	},
};
</script>
<style>
.mikasmallz {
  padding-top: 0;
  padding-bottom: 0px;
}
</style>
